// pages/Home.js
import React, { useState } from "react";
import Header from "../components/home/Header";
import BannerSection from "../components/home/BannerSection";
import WhatWeDo from "../components/home/WhatWeDo";
import OurWork from "../components/home/OurWork";
import Services from "../components/home/Service";
import IndustryWeServe from "../components/home/IndustryWeServe";
import CountsAndTestimonials from "../components/home/Testimonials";
import BlogSection from "../components/home/BlogSection";
import CallToActionSection from "../components/home/CallToActionSection";
import RequestQuote from "../components/home/RequestQuote";
import Footer from "../components/home/Footer";

function HomePage() {
  const [showServices, setShowServices] = useState(false);

  const handleServicesClick = () => {
    setShowServices(!showServices);
  };

  return (
    <div>
      
        <Header onServicesClick={handleServicesClick} />
        <BannerSection />
        <WhatWeDo />
        <OurWork />
        <IndustryWeServe />
        <CountsAndTestimonials />
        <BlogSection />
        <CallToActionSection />
        <RequestQuote />
        <Footer />
        {showServices && <Services />}
    </div>
  );
}

export default HomePage;
